var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-body" }, [
    _c("div", { staticClass: "text-size-20" }, [
      _vm._v(
        "\n    売上アップの可能性がある商品を見つけ、推奨アクションをご提案します。\n  "
      )
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm.disablePromotion && !_vm.isBasicPlan
      ? _c(
          "div",
          {
            staticClass: "action-panel",
            staticStyle: { "max-width": "700px" }
          },
          [
            _c("div", { staticClass: "action-label" }, [
              _vm._v("推奨アクション")
            ]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flexbox justify-between align-center gap-20" },
              [
                _c("p", [
                  _vm._v(
                    "広告運用に申し込み、商品の露出と販売機会を広げましょう。"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-orange",
                    on: {
                      click: function($event) {
                        _vm.$router.push("/promotion/top")
                      }
                    }
                  },
                  [
                    _vm._v("\n        広告運用を開始する\n        "),
                    _c("i", {
                      staticClass: "fa fa-angle-right",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ]
            )
          ]
        )
      : _c(
          "div",
          { staticClass: "action-panel" },
          [
            _vm.isBasicPlan ? _c("premium-modal") : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "action-label" }, [
              _vm._v("推奨アクション")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "action-title-row" }, [
              _c("h4", { staticClass: "action-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.products.length > 0
                      ? "広告に登録する"
                      : "広告運用を継続する"
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "action-title-right" }, [
                _vm.selectedItems.length > 0
                  ? _c("span", { staticClass: "selected-count" }, [
                      _vm._v(_vm._s(_vm.selectedItems.length) + "件選択中")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isBasicPlan &&
                !_vm.disablePromotion &&
                _vm.products.length > 0
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-orange",
                        attrs: { disabled: _vm.selectedItems.length === 0 },
                        on: { click: _vm.bulkAddPromotion }
                      },
                      [_vm._v("選択した商品を広告に登録する")]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.products.length > 0
                      ? "広告に登録する商品を選択してください。複数の商品をまとめて登録できます。"
                      : "現在の設定のまま広告運用を継続し、販売機会を広げていきましょう。"
                  ) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _vm.products.length > 0
              ? _c("div", { staticClass: "expansion-table" }, [
                  _c("table", { staticClass: "full-width bg-white" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { staticClass: "col-check" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.isCheckAll,
                                expression: "isCheckAll"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.isCheckAll)
                                ? _vm._i(_vm.isCheckAll, null) > -1
                                : _vm.isCheckAll
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.isCheckAll,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.isCheckAll = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.isCheckAll = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.isCheckAll = $$c
                                  }
                                },
                                _vm.handleSelectAll
                              ]
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "col-info" }, [
                          _vm._v("商品情報")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.products, function(item) {
                        return _c("tr", { key: item.asin }, [
                          _c("td", { staticClass: "col-check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedItems,
                                  expression: "selectedItems"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: item.asin,
                                checked: Array.isArray(_vm.selectedItems)
                                  ? _vm._i(_vm.selectedItems, item.asin) > -1
                                  : _vm.selectedItems
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.selectedItems,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = item.asin,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.selectedItems = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.selectedItems = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.selectedItems = $$c
                                  }
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "col-info" }, [
                            _c(
                              "div",
                              { staticClass: "flexbox gap-10 no-wrap" },
                              [
                                _c("img", {
                                  staticClass: "product-img",
                                  attrs: { src: item.image, alt: "" }
                                }),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "tooltip-wrapper" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text--underline product-name",
                                          attrs: {
                                            href:
                                              "https://www.amazon.co.jp/gp/offer-listing/" +
                                              item.asin,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.sliceProductName(
                                                item.productName
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "tooltip-text" },
                                        [_vm._v(_vm._s(item.productName))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "flexbox gap-20" }, [
                                    _c("div", [
                                      _c("span", { staticClass: "font-bold" }, [
                                        _vm._v("SKU：")
                                      ]),
                                      _vm._v(_vm._s(item.sku))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("span", { staticClass: "font-bold" }, [
                                        _vm._v("ASIN：")
                                      ]),
                                      _vm._v(_vm._s(item.asin))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("span", { staticClass: "font-bold" }, [
                                        _vm._v("FNSKU：")
                                      ]),
                                      _vm._v(_vm._s(item.fnsku))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "flexbox gap-20" }, [
                                    _c("span", [
                                      _vm._v("Amazon価格："),
                                      _c("b", [
                                        _vm._v(
                                          "¥" +
                                            _vm._s(
                                              _vm.formatNumber(item.amazonPrice)
                                            )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v("在庫数："),
                                      _c("b", [_vm._v(_vm._s(item.quantity))])
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v("Amazon受取金額："),
                                      _c("b", [
                                        _vm._v(
                                          "¥" +
                                            _vm._s(
                                              _vm.formatNumber(item.offerPrice)
                                            )
                                        )
                                      ])
                                    ])
                                  ])
                                ])
                              ]
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                ])
              : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fba-longterm-banner" }, [
      _c("div", { staticClass: "fba-longterm-icon" }),
      _vm._v(" "),
      _c("fieldset", [
        _c("legend", [_vm._v("注目!")]),
        _vm._v(" "),
        _c("div", { staticClass: "fba-longterm-content" }, [
          _vm._v(
            "\n        推奨アクションを実施して、売上アップにつなげましょう！\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "action-title-row" }, [
      _c("h4", { staticClass: "action-title" }, [_vm._v("広告運用を開始する")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2867b81e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2867b81e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/salemonAgent/SalesExpansion.vue
// module id = null
// module chunks = 